<template>
  <div class="main">
    <v-overlay :value="loading" z-index="9999">
      <v-progress-circular
        indeterminate
        color="#FB966E"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <iframe ref="Iframe" class="iframe" :style="{'border':border, 'height':height}" :src="url" :scrolling="scrolling"></iframe>
  </div>
</template>

<script>

export default {
  name: 'DefaultIframe',
  props: {
    url: {
      type: [String],
    },
    scrolling: {
      type: [String],
    },
    border: {
      type: [String],
    },
    height: {
      type: [String],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    iframeLoad() {
      this.loading = true;
      const iframe = this.$refs.Iframe;
      if (iframe.attachEvent) { // IE
        iframe.attachEvent('onload', () => { this.loading = false; });
      } else { // 非IE
        iframe.onload = () => { this.loading = false; };
      }
    },
  },
  watch:
  {
    url() {
      this.iframeLoad();
    },
  },
  mounted() {
    this.iframeLoad();
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: calc(100% - 76px);
}

.iframe {
  width: 100%;
  height: 100vh;
  background-color: white;
}

</style>
